import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  thirdPartyRecords: [],
  totalPages: 0,
  thirdPartyById: null,
};

export const ThirdPartySlice = createSlice({
  name: "ThirdParty",
  initialState,
  reducers: {
    getThirdPartyRecords: (state, action) => {
      state.thirdPartyRecords = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    getThirdPartyById: (state, action) => {
      state.thirdPartyById = action.payload;
    },
    resetThirdPartyById: (state, action) => {
      state.thirdPartyById = null;
    },
  },
});

export const { getThirdPartyRecords, getThirdPartyById, resetThirdPartyById } =
  ThirdPartySlice.actions;

export default ThirdPartySlice.reducer;
